const skills=[
    {
        "name": "Web Development",
        "description": "Building interactive websites using HTML, CSS, JavaScript, and frameworks like React and Angular."
    },
    {
        "name": "Cloud Computing",
        "description": "Deploying and managing applications on AWS, Google Cloud, and Azure."
    },
    {
        "name": "Data Science",
        "description": "Using Python, R, and SQL to analyze data and drive business insights."
    },
    {
        "name": "Machine Learning",
        "description": "Developing AI-powered applications using TensorFlow, PyTorch, and Scikit-learn."
    },
    {
        "name": "Cybersecurity",
        "description": "Protecting systems from cyber threats using firewalls, encryption, and penetration testing."
    },
    {
        "name": "Mobile App Development",
        "description": "Creating Android and iOS apps using Swift, Kotlin, Flutter, and React Native."
    },
    {
        "name": "DevOps",
        "description": "Automating software deployment with Docker, Kubernetes, and CI/CD pipelines."
    },
    {
        "name": "Blockchain",
        "description": "Developing smart contracts and decentralized applications using Solidity and Ethereum."
    },
    {
        "name": "Artificial Intelligence (AI)",
        "description": "Building AI systems for automation, NLP, and computer vision."
    },
    {
        "name": "UI/UX Design",
        "description": "Designing user-friendly interfaces using Figma, Adobe XD, and Sketch."
    },
    {
        "name": "Big Data Analytics",
        "description": "Processing massive datasets using Hadoop, Spark, and NoSQL databases."
    },
    {
        "name": "Software Testing",
        "description": "Ensuring software quality with automated testing frameworks like Selenium and Jest."
    },
    {
        "name": "Internet of Things (IoT)",
        "description": "Connecting devices to the internet using Raspberry Pi, MQTT, and Arduino."
    },
    {
        "name": "Digital Marketing",
        "description": "Boosting online presence with SEO, social media marketing, and Google Ads."
    },
    {
        "name": "Database Management",
        "description": "Designing and managing databases using MySQL, PostgreSQL, and MongoDB."
    },
    {
        "name": "Networking",
        "description": "Configuring and maintaining networks using Cisco, TCP/IP, and VPN technologies."
    },
    {
        "name": "Game Development",
        "description": "Creating immersive games using Unity, Unreal Engine, and C++."
    },
    {
        "name": "Technical Writing",
        "description": "Writing documentation, API guides, and user manuals for technical products."
    },
    {
        "name": "Automation Testing",
        "description": "Developing test scripts with Selenium, Cypress, and TestNG."
    },
    {
        "name": "Robotics",
        "description": "Programming robotic systems using ROS and embedded programming."
    },
    {
        "name": "Embedded Systems",
        "description": "Developing firmware for microcontrollers and IoT applications."
    },
    {
        "name": "Computer Vision",
        "description": "Building image recognition systems using OpenCV and YOLO."
    },
    {
        "name": "Quantum Computing",
        "description": "Exploring next-gen computing using Qiskit and quantum algorithms."
    },
    {
        "name": "3D Modeling & Animation",
        "description": "Creating 3D assets for games and movies using Blender and Maya."
    },
    {
        "name": "Augmented Reality (AR) & Virtual Reality (VR)",
        "description": "Developing AR/VR applications using Unity and Unreal Engine."
    }
]
export default skills;